import * as React from 'react'
import { List } from 'immutable'
import { Link } from 'react-router-dom'
import { Breadcrumb } from '../../drupal/types_and_parser/extra_types.mod'

export const Breadcrumbs = (props: { breadcrumbs: List<Breadcrumb> }) => {
  const breadcrumbs = props.breadcrumbs

  return (
    <nav className="breadcrumb text--s">
      <div className="breadcrumb__inner container container--m grid--gutter">
        <ul className="breadcrumb__list">
          {breadcrumbs.map((b, k) => (
            <li key={`br-${k}`} className="breadcrumb__item">
              <Link
                to={b.url}
                className="breadcrumb__link"
                title={b.title}
                {...(k == breadcrumbs.size - 1 && { 'aria-current': 'location' })}
              >
                {b.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  )
}
